import { render, staticRenderFns } from "./AnimalDisposalList.vue?vue&type=template&id=50b4e948&"
import script from "./AnimalDisposalList.vue?vue&type=script&lang=js&"
export * from "./AnimalDisposalList.vue?vue&type=script&lang=js&"
import style0 from "./AnimalDisposalList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports